<template>
  <div class="field-input-radio form-group">
    <label
      v-html="fieldData.label"
      :for="fieldData.field_name"
      :class="(isRequired ? 'field-required' : '')">
    </label>

    <span v-if="tooltipContent" :id="fieldData.field_name + '_tooltip'" v-b-tooltip.hover><i class="fa fa-info-circle" aria-hidden="true"></i></span>
    <b-tooltip v-if="tooltipContent" :target="fieldData.field_name + '_tooltip'" boundary="window" placement="right">
      <div v-html="tooltipContent" class="text-left"></div>
    </b-tooltip>

    <div v-for="(item, i) in fieldData.values" :key="i" class="custom-control custom-radio smaller-font-content">
      <input
        class="custom-control-input"
        type="radio"
        v-model="fieldData.field_value"
        :value="item.internal_value"
        :disabled="(!!showDisabled())"
        :name="fieldData.field_name"
        :id="fieldData.field_name + '_radio_option_' + i"
        autocomplete="off">

      <label
        :for="fieldData.field_name + '_radio_option_' + i"
        :class="optionClasses(item, i)" style="display: block">
        <span v-html="item.display_value"></span>
      </label>
    </div>

    <div class="invalid-feedback d-block">{{ errors.first(fieldData.field_name) }}</div>

    <input
      :disabled="(!!showDisabled())"
      v-show="false"
      :name="fieldData.field_name"
      :id="fieldData.field_name"
      type="text"
      class="form-control"
      :maxlength="fieldData.max_length"
      v-model="fieldData.field_value"
      v-validate="fieldData.rules" />
  </div>
</template>

<script>
export default {
  inject: ['$validator'], // Allows this component's validation messages to appear in other components
  props: ['fieldData'],
  computed: {
    isRequired() {
      return this.fieldData.rules && this.fieldData.rules.required === true;
    },
    tooltipContent() {
      return this.fieldData.help_text;
    },
  },
  methods: {
    showDisabled() {
      return !this.fieldData.is_enabled;
    },
    optionClasses(item, i) {
      const optionClasses = {};

      optionClasses['custom-control-label'] = true;
      optionClasses[`radio_option radio_option_${i}`] = true;
      optionClasses.active = (this.fieldData.field_value === item.internal_value);

      return optionClasses;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/admin/interactive/InputRadio.vue?4adefcc4